import { defineMessages } from "react-intl"

export const messages = defineMessages({
  logIn: {
    id: "profile.login",
    defaultMessage: "Log in"
  },
  register: {
    id: "profile.register",
    defaultMessage: "Register"
  },
  changePassword: {
    id: "profile.change-password",
    defaultMessage: "Change password?"
  },
  myDetails: {
    id: "profile.my-details",
    defaultMessage: "My Details"
  },
  displayName: {
    id: "profile.display-name",
    defaultMessage: "Display Name"
  },
  confirmNewPassword: {
    id: "profile.confirm-new-password",
    defaultMessage: "Confirm New Password"
  },
  existingPassword: {
    id: "profile.existing-password",
    defaultMessage: "Existing Password"
  },
  newPassword: {
    id: "profile.new-password",
    defaultMessage: "New Password"
  },
  displayNameDefault: {
    id: "profile.display-name-default",
    defaultMessage: "Display Name *"
  },
  passwordsDontMatch: {
    id: "profile.passwords-dont-match",
    defaultMessage: "Password's don't match"
  },
  profileUpdated: {
    id: "profile.profile-updated",
    defaultMessage: "Profile successfully updated!"
  },
  error: {
    id: "profile.error",
    defaultMessage: "Whoops! Something's gone wrong. {message}"
  },
  errorCheck: {
    id: "profile.error-check",
    defaultMessage: "Please check the form above."
  },
  update: {
    id: "profile.update",
    defaultMessage: "Update"
  },
  myScrapbook: {
    id: "profile.my-scrapbook",
    defaultMessage: "My Scrapbook"
  },
  by: {
    id: "profile.by",
    defaultMessage: "by"
  },
  longerPassword: {
    id: "profile.longer-password",
    defaultMessage: "Please supply a longer password."
  },
  passwordConfirmationMismatch: {
    id: "profile.password-confirmation-mismatch",
    defaultMessage: "Sorry the password confirmation doesn't match."
  },
  invalidToken: {
    id: "error.invalid-token",
    defaultMessage: "Invalid Token"
  },
  confirmPassword: {
    id: "placeholder.confirmPassword",
    defaultMessage: "Confirm Password"
  },
  password: {
    id: "placeholder.password",
    defaultMessage: "Password"
  },
  resetLink: {
    id: "profile.password-reset-link",
    defaultMessage: "requesting a new password reset link"
  },
  resetPassword: {
    id: "profile.reset-password",
    defaultMessage: "Reset Password"
  },
  updatedPasswordSuccess: {
    id: "profile.updated-password-success",
    defaultMessage:
      "<strong>Success!</strong> You can now log in using your new password."
  },
  allDone: {
    id: "message.all-done",
    defaultMessage: "All Done"
  },
  pleaseWait: {
    id: "message.please-wait",
    defaultMessage: "Please Wait"
  },
  forgottenPassword: {
    id: "profile.forgotten-password",
    defaultMessage: "Forgotten your username or password?"
  },
  errorUserOrPass: {
    id: "profile.error-user-or-pass",
    defaultMessage: "Sorry, username or password is invalid"
  },
  or: {
    id: "profile.or",
    defaultMessage: "or"
  },
  passwordResetEmailSent: {
    id: "profile.password-reset-email-sent",
    defaultMessage:
      "Thanks, an email with password reset instructions is on the way."
  },
  sendResetEmail: {
    id: "profile.send-reset-email",
    defaultMessage: "Send Reset Email"
  },
  createAnAccount: {
    id: "profile.create-an-account",
    defaultMessage: "Create an account"
  },
  accountUnlock: {
    id: "profile.account-unlock",
    defaultMessage: "Account Unlock"
  },
  accountUnlockError: {
    id: "profile.account-unlock-error",
    defaultMessage: "Unlock URL is invalid or expired"
  },
  accountUnlockSuccess: {
    id: "profile.account-unlock-success",
    defaultMessage: "Account has been unlocked. Please log in to continue."
  },
  newContribution: {
    id: "profile.new-contribution",
    defaultMessage:
      'New<span className="hide-for-small-only"> Contribution</span>'
  },
  myContributions: {
    id: "profile.my-contributions",
    defaultMessage: "My Contributions"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/profile.js